import React, { useCallback, useEffect } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import Download from 'assets/svg-icons/Download';
import { REPORT_STATUS, FILE, FILE_URL, FILE_ID, FILE_URL_EXPIRES, BUCKET, MIMETYPE } from 'store/reports';
import { useExaminationsActions, useAlerts } from 'store/examinations';

import { RowContainer, IdField, Field, DownloadWrapper, Button } from './styles';

const Row = ({ publicId, status: reportStatus, meta, receiver, [FILE_URL]: url, [FILE]: fileData }) => {
  const getReceiver = useCallback(() => {
    const { institution, firstname, lastname } = receiver;
    if (institution) return institution;
    return `${firstname || ''} ${lastname || ''}`;
  }, [receiver]);

  const { [FILE_ID]: fileId } = fileData || {};
  const { loadFile } = useExaminationsActions();
  const { action, loading, success, resetAlerts } = useAlerts(loadFile);
  const handleClick = useCallback(() => {
    if (fileId) {
      action(fileData);
    } else if (url) {
      window.open(url, '_blank');
    }
  }, [action, fileData, fileId, url]);

  useEffect(() => {
    if (success) {
      window.open(success, '_blank');
      resetAlerts();
    }
  }, [resetAlerts, success]);

  return (
    <RowContainer key={publicId}>
      <IdField width={20}>{publicId}</IdField>
      <Field width={30}>{getReceiver()}</Field>
      <Field width={20}>{moment(meta.modified).format('DD.MM.YYYY')}</Field>
      <Field width={20}>{REPORT_STATUS.find(({ id }) => id === `${reportStatus}`)?.title}</Field>
      <DownloadWrapper width={10}>
        <Button type="button" onClick={handleClick} disabled={loading}>
          <Download />
        </Button>
      </DownloadWrapper>
    </RowContainer>
  );
};

Row.defaultProps = {
  receiver: {},
  [FILE_URL]: null,
  [FILE]: null,
};

Row.propTypes = {
  publicId: PropTypes.string.isRequired,
  status: PropTypes.number.isRequired,
  meta: PropTypes.shape({
    modified: PropTypes.string.isRequired,
  }).isRequired,
  receiver: PropTypes.shape({
    institution: PropTypes.string,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
  }),
  [FILE_URL]: PropTypes.string,
  [FILE]: PropTypes.shape({
    [FILE_ID]: PropTypes.string,
    [FILE_URL]: PropTypes.string,
    [FILE_URL_EXPIRES]: PropTypes.string,
    [BUCKET]: PropTypes.string,
    [MIMETYPE]: PropTypes.string,
  }),
};

export default Row;
